import { lazy } from 'react';

import { MY_PROFILE, V } from '../hooks/useAuthorization';
import { ALL_ROLE } from '../utils/constants/AppConstants';
import { MAINTENANCE_URL, MY_PROFILE_URL, NOT_AUTHORIZED_URL, NOT_EXITS_URL, SOMETHING_WENT_WRONG_URL } from '../utils/constants/RouteContants';
import { IRoute } from '../utils/interfaces/route';
import AccountMasterRoutes from './accountMaster';
import AnnouncementRoutes from './announcement';
import InquiryRoutes from './inquiry';
import MasterRoutes from './master';
import ProjectRoutes from './project';
import StakeholderRoutes from './stakeholder';
import TaskRoutes from './task';
import TemplateRoutes from './template';

const MyProfile = lazy(() => import('../pages/my-profile/MyProfile'));
const NotAuthorized = lazy(() => import('../pages/error-page/403-page/NotAuthorized'));
const NotExits = lazy(() => import('../pages/error-page/404-page/NotExits'));
const SomeThingWentWrong = lazy(() => import('../pages/error-page/500-page/SomeThingWentWrong'));
const MaintenancePage = lazy(() => import('../pages/maintenance'));

const ROUTES: IRoute[] = [
  {
    path: MY_PROFILE_URL,
    name: MY_PROFILE,
    action: V,
    element: <MyProfile />,
    auth: true,
    role: ALL_ROLE
  },
  {
    path: SOMETHING_WENT_WRONG_URL,
    name: 'SOMETHING_WENT_WRONG',
    action: V,
    element: <SomeThingWentWrong />,
    auth: false,
    role: ALL_ROLE
  },
  {
    path: NOT_AUTHORIZED_URL,
    name: 'NOT_AUTHORIZED_',
    action: V,
    element: <NotAuthorized />,
    auth: false,
    role: ALL_ROLE
  },
  {
    path: NOT_EXITS_URL,
    name: 'NOT_EXITS',
    action: V,
    element: <NotExits />,
    auth: false,
    role: ALL_ROLE
  },
  {
    path: MAINTENANCE_URL,
    name: 'MAINTENANCE',
    action: V,
    element: <MaintenancePage />,
    auth: false,
    role: ALL_ROLE
  },
  ...ProjectRoutes,
  ...TaskRoutes,
  ...TemplateRoutes,
  ...AccountMasterRoutes,
  ...MasterRoutes,
  ...AnnouncementRoutes,
  ...InquiryRoutes,
  ...StakeholderRoutes
];

export default ROUTES;
